class TableOfContents extends HTMLElement {
  tocHeadingElementClass = 'toc-heading';
  tocEntriesElementClass = 'toc-entries';
  tocElementClass = 'toc-element';
  tocSelectedClass = 'toc-selected';

  constructor() {
    super();

    window.addEventListener("DOMContentLoaded", this.init.bind(this));
  }

  init() {
    if (this.dataset.content !== undefined) {
      this.contentElement = document.querySelector(this.dataset.content);
      if (!this.contentElement) {
        console.log(`TOC: couldn't find element ${this.dataset.content}`);
      } else {
        this.initTOC();
      }
    }
  }

  initTOC() {
    this.elements = this.contentElement.querySelectorAll("h1[id],h2[id],h3[id],h4[id],h5[id],h6[id]");
    this.tocItems = [];

    this.headingElement = document.createElement('div');
    this.headingElement.innerHTML = this.innerHTML;
    this.headingElement.classList.add(this.tocHeadingElementClass);
    this.textContent = '';
    this.appendChild(this.headingElement);

    this.entriesElement = document.createElement('div');
    this.entriesElement.classList.add(this.tocEntriesElementClass);
    this.appendChild(this.entriesElement);

    this.elements.forEach(element => {
      const d = document.createElement('div');
      d.dataset.for = element.id;
      d.classList.add(this.tocElementClass);
      const a = document.createElement('a');
      a.textContent = element.textContent;
      a.href = `#${element.id}`;
      if (element.dataset.tocText) a.textContent = element.dataset.tocText;
      d.appendChild(a);
      this.entriesElement.appendChild(d);
      this.tocItems.push(d);
    });


    this.observer = new IntersectionObserver(this.observer.bind(this), {threshold: .5});
    this.visibleItems = [];
    this.elements.forEach((element, index) => {
      this.observer.observe(element);
      this.visibleItems[index] = false;
    });

    this.addEventListener('click', this.toggleTOC.bind(this));

    if (this.elements.length) this.style.display = 'block';
  }

  observer(entries) {
    entries.forEach(entry => {
      const index = this.tocItems.findIndex(element => element.dataset.for === entry.target.id);
      this.visibleItems[index] = entry.isIntersecting;
    });

    const firstVisibleItem = this.visibleItems.findIndex(element => element);
    if (firstVisibleItem >= 0) {
      this.selectFirstVisibleTocItem(firstVisibleItem);
    }
  }

  getFirstVisibleTocItem() {
    for (let i = 0; i < this.elements.length; i++) {
      const rect = this.elements[i].getBoundingClientRect();
      const viewHeight = document.documentElement.clientHeight;
      if (rect.bottom > 0 && rect.top < viewHeight - (rect.height/2)){
        return i;
      }
    }

    return -1;
  }

  selectFirstVisibleTocItem(i) {
    this.tocItems.forEach(tocItem => tocItem.classList.remove(this.tocSelectedClass));
    if (i === undefined) i = this.getFirstVisibleTocItem();
    const visibleItem = i;
    if (visibleItem < 0) return;
    this.tocItems[visibleItem].classList.add(this.tocSelectedClass);
  }

  toggleTOC() {
    this.classList.toggle('opened');
  }

}

customElements.define('table-of-contents', TableOfContents);

